!function($) {

  // Add custom JavasScript here
  // --------------------------



  // Document ready
  $(function() {


  });

}(jQuery);

// Remove leftover Hextom notify-bar if it exists
document.addEventListener('DOMContentLoaded', function() {
    var notifyBar = document.getElementById('notify-bar');
    if (notifyBar) {
        notifyBar.remove();
    }

    // Also remove any dynamically injected divs starting with notify-bar
    var dynamicBars = document.querySelectorAll('div[id^="notify-bar"]');
    dynamicBars.forEach(function(el) {
        el.remove();
    });
});
